import { useMemo } from 'react';
import { RoundsSummary } from 'spw-redux/modules/ou/types';
import { Category } from 'spw-redux/modules/space_types/types';

export const useSelectedCategories = (roundsSummary?: RoundsSummary) => {
  return useMemo(() => {
    if (roundsSummary?.categoriesRelated) {
      return Object.keys(roundsSummary.categoriesRelated).filter((category) => {
        return roundsSummary.categoriesRelated[category];
      }) as Category[];
    }
    return [] as Category[];
  }, [roundsSummary]);
};
